import axios from "axios";

export const apiClient = axios.create({
  withCredentials: false,
});

export const apiClientFile = axios.create({
  withCredentials: false,
});
